<template>
  <div class="detail-wrapper">
    <div class="title">{{detail.title}}</div>
    <div class="detail">
      <span>添加时间:{{detail.up_time | parseTime('{y}-{m}-{d}')}}</span>
      <span>来源:国家海洋标准计量中心</span>
    </div>
    <div class="article-content ql-editor" v-html="detail.content"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["detail"],
  methods: {}
};
</script>

<style scoped>
.detail-wrapper {
  width: 100%;
}
.title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  line-height: 35px;
}
.detail {
  font-size: 0;
  text-align: center;
  margin-bottom: 30px;
}
.detail > span {
  font-size: 14px;
  margin: 0 10px;
}
.article-content {
  font-size: 16px;
  line-height: 30px;
}
.article-content p {
  font-size: 16px;
  color: #222;
  margin-bottom: 20px;
}
.detail-wrapper img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
</style>




// WEBPACK FOOTER //
// src/components/views/Organization/Children/childDetail.vue